export const REFRESH_USER_COUNT = 'REFRESH_USER_COUNT';

import { get, put, post, destroy } from 'utils/fetchRequest';

export const getBranchList = async (searchText, id) => {
    try {
        let queryParams = '';
        if (searchText) {
            queryParams += `?search=${searchText}`;
        }
        if (id) {
            queryParams += `${queryParams ? '&' : '?'}id=${id}`;
        }

        // Send the request with the constructed query parameters
        const result = await get(`branch${queryParams}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createBranch = async (data) => {
    try {
        const result = await post('branch', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updateBranch = async (id, data) => {
    try {
        const result = await put(`branch/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const deleteBranch = async (id) => {
    try {
        const result = await destroy(`branch/${id}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

